
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-x-request-demo-basic","docs-x-sdk-x-request-demo-custom-params-headers","docs-x-sdk-x-request-demo-custom-transformer","docs-x-sdk-x-request-demo-manual","docs-x-sdk-x-request-demo-timeout"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.en-US.md?type=demo')
};